// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pt-pricelist-app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.pt-container{background-color:#1a546b;padding:3em 0 4em 0}.pt-container>div{max-width:960px;margin:0 auto}.pt-pricelist-content{padding:0 1em;margin-bottom:1.5em;text-align:center}.pt-pricelist-content>h2{color:#fff;font-weight:400;text-transform:uppercase;letter-spacing:3px}.fade-enter-active,.fade-leave-active{transition:opacity .25s ease-out}.fade-enter,.fade-leave-to{opacity:0}", ""]);
// Exports
module.exports = exports;
